import Chart from 'chart.js/auto';

export const hex2rgba = (hex, alpha = 1) => {
    const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16));
    return `rgba(${r},${g},${b},${alpha})`;
};

export const createCardLineChart = (element, data, borderColor = '#06b6d4', fillColor = '#22d3ee') => {
    var ctx = element.getContext("2d");
    var gradient = ctx.createLinearGradient(0, 0, 0, 80);
    gradient.addColorStop(0, hex2rgba(fillColor, 0.3));
    gradient.addColorStop(1, hex2rgba(fillColor, 0));

    return new Chart(element, {
        type: 'line',
        data: {
            datasets: [{
                data,
                borderColor,
                backgroundColor: gradient,
                borderWidth: 3,
                tension: 0.4,
                fill: true,
            }]
        },
        options: {
            radius: 0,
            hoverRadius: 0,
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                x: { display: false },
                y: { display: false },
            },
            plugins: {
                legend: { display: false },
                tooltip: { enabled: false },
            },
            layout: {
                autoPadding: false,
                padding: { top: 5 },
            },
        }
    });
}
